// extracted by mini-css-extract-plugin
export default {"collaborators":"collaborators_collaborators__fXbce"};